import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LeftBorderAlerts } from "../../../../Constant";
import { LEFT_DATA } from "../../../../Data/UiKit/Alert";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import { HelpCircle } from "react-feather";

const LeftBorderAlert = () => {
  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={LeftBorderAlerts} span={LEFT_DATA} />
        <CardBody className="live-dark">
          <Alerts isOpen={visible} color="light-dark" className="light alert-dismissible fade show text-dark border-left-wrapper">
            <HelpCircle />
            <P>You can check in on some of those fields below.</P>
            <Btn className="btn-close" onClick={onDismiss}></Btn>
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LeftBorderAlert;
